import React from 'react';

const SectionEyebrow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="inline-flex items-center gap-2 app-caption text-indigo-600 dark:text-indigo-400">
    <span className="h-px w-6 bg-indigo-400/60 dark:bg-indigo-500/60" />
    {children}
  </span>
);

export default SectionEyebrow;
